import * as React from 'react'
import Layout from '@components/Layout/Layout'
import {Text} from '@components/base/Text'
import OverlappingSection from '@components/OverlappingSection'
import {Flex} from '@components/base/Flex'
import styled from 'styled-components'
import {TextAreaInput, TextInput} from '@components/base/TextInput'
import {AccentButton} from '@components/base/Button'
import {breakpoints} from '../styles/utils'
import {useTranslation} from 'react-i18next'
import {graphql} from 'gatsby'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import axios from "axios";
import {useState} from "react";

const StyledIframe = styled.iframe`
  border: 0;
  max-width: 100%;
`

export const InputContainer = styled(Flex)`
  border: 1px solid lightgray;
  border-radius: 4px;

  &:focus-within {
    border: 1px solid ${({theme}) => theme.color.background};
  }

  span {
    cursor: none;
    pointer-events: none;
  }

  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
    background-color: transparent;
    position: relative;
    transform: translateX(0);
    width: auto;
    height: auto;
  }
`
const BodyContainer = styled(Flex)`
  flex-direction: column;
  flex-wrap: wrap;
  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
  }
`


const StyledContactForm = styled.form`
  row-gap: 20px;
  overflow: hidden;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  display: flex;

`
const initialValues = {
    message: '',
    phoneNumber: '',
    fullName: '',
    'form-name': 'contact'
}

type ContactForm = typeof initialValues

const Contact = () => {
    const {t} = useTranslation()
    const [submitted, setSubmitted] = useState(false);

    const onSubmit = async () => {
        let myForm = document.getElementById("contact");
        let formData = new FormData(myForm);
        await fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString(),
        });
        setSubmitted(true);
        return null;
    }

    const {getFieldProps, handleSubmit, isValid, isSubmitting, dirty, submitCount} = useFormik<ContactForm>({
        initialValues,
        validationSchema: Yup.object({
            message: Yup.string().required(),
            phoneNumber: Yup.string().required(),
            fullName: Yup.string().required(),
        }),
        onSubmit,
    })

    return (
        <Layout layoutType={'fullScreen'} occupySpace={false}>
            <OverlappingSection
                Header={
                    <Text bolded type={'h1'}>
                        {t('menu:contact')}
                    </Text>
                }
                Body={
                    <BodyContainer direction={'row'} flex={1}>
                        <Flex flex={1} direction={'column'}>
                            <StyledIframe
                                width="600"
                                height="450"
                                loading="lazy"
                                allowFullScreen
                                src="https://www.google.com/maps/embed/v1/place?q=place_id:GhIJN4lBYOWGP0ARokW28_03QUA&key=AIzaSyCIQkZOvMG-Ap_2u7QD7v0q8qeK66mWLZY"
                            />
                        </Flex>
                        {submitted && <Text type={'body'} centered>Submission Sent - We will be in touch.</Text>}
                        {!submitted  && <StyledContactForm name={'contact'} id="contact" onSubmit={handleSubmit} method="POST" data-netlify="true">
                            <input type="hidden" name="form-name" value="contact" />

                            <InputContainer direction={'row'} alignItems={'center'}>
                                <Text color={'background'} bolded>
                                    {t('booking:full-name')}
                                </Text>
                                <TextInput {...getFieldProps('fullName')} fullWidth placeholder={'John Doe'}/>
                            </InputContainer>
                            <InputContainer direction={'row'} alignItems={'center'}>
                                <Text color={'background'} bolded>
                                    {t('booking:phone_number')}
                                </Text>
                                <TextInput
                                    {...getFieldProps('phoneNumber')}
                                    fullWidth
                                    placeholder={'+970 000 000 0000'}
                                />
                            </InputContainer>
                            <InputContainer>
                                <Text color={'background'} bolded>
                                    Message
                                </Text>
                                <TextAreaInput
                                    {...getFieldProps('message')}
                                    placeholder={'What would you like to ask us?'}
                                    maxLength={500}
                                    fullWidth
                                    aria-autocomplete={'both'}
                                />
                            </InputContainer>
                            <AccentButton
                                type={'submit'}
                                disabled={isSubmitting || !isValid || !dirty}
                                textColor={'black'}
                                onClick={handleSubmit}
                            >
                                Send Message
                            </AccentButton>
                        </StyledContactForm>}
                    </BodyContainer>
                }
            />
        </Layout>
    )
}

export const pageQuery = graphql`
    query ContactPageTemplate($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`

export default Contact
